import { useParams } from '@fs/zion-router'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { usePageView } from '@fs/zion-analytics'
import ChatMessages from './messages/ChatMessages'
import ChatSummary from './summary/ChatSummary'
import useChat from './useChat'
import MetaData from '../metadata/MetaData'
import SubnavAndRoutes from '../app/SubnavAndRoutes'
import ChatContextProvider from './ChatContextProvider'
import { usePageTitle } from '../app/PageTitleContext'

export default function ChatBase() {
  usePageView({ page_detail: 'DMConsole:ChatBase' })
  const { t } = useTranslation()
  usePageTitle(t('pageTitle.chat.base'))
  const params = useParams()
  const channelId = params.channelId
  const { chat, fetchChat, parentMessage } = useChat(channelId)
  const chatContext = { chat, fetchChat, parentMessage }
  const subNavs = [
    {
      text: t('summary', 'Summary'),
      path: `summary`,
      requiredPermissions: 'FtLoginPermission',
      component: ChatSummary,
    },
    {
      text: t('messages', 'Messages'),
      path: `messages`,
      requiredPermissions: 'FtLoginPermission',
      component: ChatMessages,
    },
  ]
  const metadata = {
    header: `${chat?.type}:${chat?.name}` === chat?.cid ? t(`chat.type.${chat.type}`, chat.type) : chat?.name,
    items: [
      {
        label: t('chat.channelId', 'Channel ID'),
        showLabel: true,
        itemType: 'single',
        field: 'channelId',
        value: {
          value: chat?.cid,
        },
      },
    ],
  }
  if (parentMessage) {
    metadata.items.push({
      id: 'Chat Parent Channel ID',
      label: t('chat.parentChannelId', 'Parent Channel ID'),
      showLabel: true,
      itemType: 'single',
      value: {
        newTab: true,
        path: `/chat/${parentMessage.cid}/summary`,
        value: parentMessage.cid,
      },
    })
  }

  if (!channelId) {
    return t('chat.baseMessage', 'Look up a channel to view channel data')
  }
  if (!chat) {
    return null
  }

  return (
    <ChatContextProvider value={chatContext}>
      <MetaData metadata={metadata} />
      <SubnavAndRoutes data={subNavs} />
    </ChatContextProvider>
  )
}
